import { SettingsPageFrame } from '@eluve/blocks';
import { LayersPage } from '@eluve/frontend-feature-tenants';
import { useTranslation } from '@eluve/i18n';

export const OrganizationLayersPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <SettingsPageFrame
      size="wide"
      title={t('settings.organization.layers')}
      parentTitle={t('settings.nav.organization')}
      backTo="../organization"
      description={t('settings.organization.layersDescription')}
    >
      <LayersPage />
    </SettingsPageFrame>
  );
};
